export default __webpack_public_path__ + "static/media/Commercial Zone.6ead643e.jpg";